<template>
  <ol
    itemscope
    itemtype="http://schema.org/BreadcrumbList"
    class="breadcrumb-lists"
  >
    <li
      itemprop="itemListElement"
      itemscope
      itemtype="http://schema.org/ListItem"
      class="breadcrumb-lists-item"
    >
      <a title="トップへ戻ります" href="/" itemprop="item">
        <span itemprop="name" class="breadcrumb-lists-home"></span>
      </a>
      <meta itemprop="position" content="1" />
    </li>

    <li
      itemprop="itemListElement"
      itemscope
      itemtype="http://schema.org/ListItem"
      class="breadcrumb-lists-item breadcrumb-list-item-parent"
      v-for="list in breadcrumbs"
      :key="list.name"
    >
      <a :href="list.path" itemprop="item" class="js-link-animation-inside">
        <span itemprop="name">{{ list.name }}</span>
      </a>
      <meta itemprop="position" content="2" />
    </li>
  </ol>
</template>

<script>
export default {
  props: ["breadcrumbs"],
};
</script>
